import React from 'react';
import { AuditNotesTable, COLUMNS } from '@css-xp/ppc-audit-notes-table';

export interface AuditTrailProps {
  id: string;
  label: string;
  isDesignIteration1Enabled?: boolean;
}

export const AuditTrailTab = ({ id, label, isDesignIteration1Enabled }: AuditTrailProps) => {
  return (
    <div className="transaction-account-tab" data-testid="transaction-account-audit-trail">
      <AuditNotesTable id={id} label={label} isDesignIteration1Enabled={isDesignIteration1Enabled} />
    </div>
  );
};
